<div class="head-wrapper">
  <div class="head-item">
    <app-wiper-loading />
  </div>
  <div class="head-item" style="width: 19%">
    <app-wiper-loading />
  </div>
  <div class="head-item">
    <app-wiper-loading />
  </div>
</div>
